import { useMemo } from 'react';
import { stringFormatting } from '../../helpers/utils';

type Statistic = { name: string, data: any };

type MoreStatisticsPickerProps = {
    supportedStatistics: Statistic[],
    statisticsToShow: Statistic[],
    onToggle: (stat: Statistic) => void,
    onCheckUncheckAll: (checkState: boolean) => void,
};

// The "More Statistics" dropdown used on the SQL Statistics tabs to pick which
// additional per-statistic charts are displayed below the duration/executions chart.
export default function MoreStatisticsPicker(props: MoreStatisticsPickerProps) {
    const { supportedStatistics, statisticsToShow, onToggle, onCheckUncheckAll } = props;

    const sortedList = useMemo(() => {
        return [...supportedStatistics].sort((a, b) => a.name.localeCompare(b.name));
    }, [supportedStatistics]);

    return (
            <div className="btn-group float-end dropdown ">
                {supportedStatistics.length ?
                        <button type="button" id="filter1" className="btn btn-dropdown dropdown-toggle"
                                data-bs-toggle="dropdown" aria-expanded="false">More Statistics
                        </button> : ''}
                <div id="dropdown-menu" className="row g-0 dropdown-menu dropdown-menu-scroll"
                     aria-labelledby="filter" onClick={(e) => e.stopPropagation()}>
                    <div className='select-all'>
                        <span onClick={() => onCheckUncheckAll(true)}>All</span><label
                            className='separator'>|</label><span
                            onClick={() => onCheckUncheckAll(false)}>None</span>
                    </div>
                    <div className='statistics-list'>
                        {sortedList.map(statistic => (
                                <div key={statistic.name}>
                                    <input className="form-check-input" type="checkbox" id={`option_${statistic.name}`}
                                           checked={!!statisticsToShow.find(item => item.name === statistic.name)}
                                           onChange={() => onToggle(statistic)}
                                    />
                                    <label htmlFor={`option_${statistic.name}`}>{stringFormatting(statistic.name)}</label>
                                </div>
                        ))}
                    </div>
                </div>
            </div>
    );
}
